Object.defineProperty(exports, "__esModule", {
    value: true
});
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var _type_of = require("@swc/helpers/_/_type_of");
var require_logger = require('./logger.cjs');
var require_tool = require('./tool.cjs');
var require_global = require('../global.cjs');
var require_constant = require('../constant.cjs');
var require_index = require('./semver/index.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
//#region src/utils/share.ts
function formatShare(shareArgs, from, name, shareStrategy) {
    var _shareArgs_shareConfig, _shareArgs_treeShaking;
    var get;
    if ("get" in shareArgs) get = shareArgs.get;
    else if ("lib" in shareArgs) get = ()=>Promise.resolve(shareArgs.lib);
    else get = ()=>Promise.resolve(()=>{
            require_logger.error(`Cannot get shared "${name}" from "${from}": neither "get" nor "lib" is provided in the share config.`);
        });
    if (((_shareArgs_shareConfig = shareArgs.shareConfig) === null || _shareArgs_shareConfig === void 0 ? void 0 : _shareArgs_shareConfig.eager) && ((_shareArgs_treeShaking = shareArgs.treeShaking) === null || _shareArgs_treeShaking === void 0 ? void 0 : _shareArgs_treeShaking.mode)) require_logger.error(`Invalid shared config for "${name}" from "${from}": cannot use both "eager: true" and "treeShaking.mode" simultaneously. Choose one strategy.`);
    return _object_spread_props._(_object_spread._({
        deps: [],
        useIn: [],
        from,
        loading: null
    }, shareArgs), {
        shareConfig: _object_spread._({
            requiredVersion: `^${shareArgs.version}`,
            singleton: false,
            eager: false,
            strictVersion: false
        }, shareArgs.shareConfig),
        get,
        loaded: (shareArgs === null || shareArgs === void 0 ? void 0 : shareArgs.loaded) || "lib" in shareArgs ? true : void 0,
        version: shareArgs.version ?? "0",
        scope: Array.isArray(shareArgs.scope) ? shareArgs.scope : [
            shareArgs.scope ?? "default"
        ],
        strategy: (shareArgs.strategy ?? shareStrategy) || "version-first",
        treeShaking: shareArgs.treeShaking ? _object_spread_props._(_object_spread._({}, shareArgs.treeShaking), {
            mode: shareArgs.treeShaking.mode ?? "server-calc",
            status: shareArgs.treeShaking.status ?? _module_federation_sdk.TreeShakingStatus.UNKNOWN,
            useIn: []
        }) : void 0
    });
}
function formatShareConfigs(prevOptions, newOptions) {
    var shareArgs = newOptions.shared || {};
    var from = newOptions.name;
    var newShareInfos = Object.keys(shareArgs).reduce((res, pkgName)=>{
        var arrayShareArgs = require_tool.arrayOptions(shareArgs[pkgName]);
        res[pkgName] = res[pkgName] || [];
        arrayShareArgs.forEach((shareConfig)=>{
            res[pkgName].push(formatShare(shareConfig, from, pkgName, newOptions.shareStrategy));
        });
        return res;
    }, {});
    var allShareInfos = _object_spread._({}, prevOptions.shared);
    Object.keys(newShareInfos).forEach((shareKey)=>{
        if (!allShareInfos[shareKey]) allShareInfos[shareKey] = newShareInfos[shareKey];
        else newShareInfos[shareKey].forEach((newUserSharedOptions)=>{
            if (!allShareInfos[shareKey].find((sharedVal)=>sharedVal.version === newUserSharedOptions.version)) allShareInfos[shareKey].push(newUserSharedOptions);
        });
    });
    return {
        allShareInfos,
        newShareInfos
    };
}
function shouldUseTreeShaking(treeShaking, usedExports) {
    if (!treeShaking) return false;
    var status = treeShaking.status, mode = treeShaking.mode;
    if (status === _module_federation_sdk.TreeShakingStatus.NO_USE) return false;
    if (status === _module_federation_sdk.TreeShakingStatus.CALCULATED) return true;
    if (mode === "runtime-infer") {
        if (!usedExports) return true;
        return isMatchUsedExports(treeShaking, usedExports);
    }
    return false;
}
/**
* compare version a and b, return true if a is less than b
*/ function versionLt(a, b) {
    var transformInvalidVersion = (version)=>{
        if (!Number.isNaN(Number(version))) {
            var splitArr = version.split(".");
            var validVersion = version;
            for(var i = 0; i < 3 - splitArr.length; i++)validVersion += ".0";
            return validVersion;
        }
        return version;
    };
    if (require_index.satisfy(transformInvalidVersion(a), `<=${transformInvalidVersion(b)}`)) return true;
    else return false;
}
var findVersion = (shareVersionMap, cb)=>{
    var callback = cb || function(prev, cur) {
        return versionLt(prev, cur);
    };
    return Object.keys(shareVersionMap).reduce((prev, cur)=>{
        if (!prev) return cur;
        if (callback(prev, cur)) return cur;
        if (prev === "0") return cur;
        return prev;
    }, 0);
};
var isLoaded = (shared)=>{
    return Boolean(shared.loaded) || typeof shared.lib === "function";
};
var isLoading = (shared)=>{
    return Boolean(shared.loading);
};
var isMatchUsedExports = (treeShaking, usedExports)=>{
    if (!treeShaking || !usedExports) return false;
    var treeShakingUsedExports = treeShaking.usedExports;
    if (!treeShakingUsedExports) return false;
    if (usedExports.every((e)=>treeShakingUsedExports.includes(e))) return true;
    return false;
};
function findSingletonVersionOrderByVersion(shareScopeMap, scope, pkgName, treeShaking) {
    var versions = shareScopeMap[scope][pkgName];
    var version = "";
    var useTreesShaking = shouldUseTreeShaking(treeShaking);
    var callback = function callback(prev, cur) {
        if (useTreesShaking) {
            if (!versions[prev].treeShaking) return true;
            if (!versions[cur].treeShaking) return false;
            return !isLoaded(versions[prev].treeShaking) && versionLt(prev, cur);
        }
        return !isLoaded(versions[prev]) && versionLt(prev, cur);
    };
    if (useTreesShaking) {
        version = findVersion(shareScopeMap[scope][pkgName], callback);
        if (version) return {
            version,
            useTreesShaking
        };
        useTreesShaking = false;
    }
    return {
        version: findVersion(shareScopeMap[scope][pkgName], callback),
        useTreesShaking
    };
}
var isLoadingOrLoaded = (shared)=>{
    return isLoaded(shared) || isLoading(shared);
};
function findSingletonVersionOrderByLoaded(shareScopeMap, scope, pkgName, treeShaking) {
    var versions = shareScopeMap[scope][pkgName];
    var version = "";
    var useTreesShaking = shouldUseTreeShaking(treeShaking);
    var callback = function callback(prev, cur) {
        if (useTreesShaking) {
            if (!versions[prev].treeShaking) return true;
            if (!versions[cur].treeShaking) return false;
            if (isLoadingOrLoaded(versions[cur].treeShaking)) if (isLoadingOrLoaded(versions[prev].treeShaking)) return Boolean(versionLt(prev, cur));
            else return true;
            if (isLoadingOrLoaded(versions[prev].treeShaking)) return false;
        }
        if (isLoadingOrLoaded(versions[cur])) if (isLoadingOrLoaded(versions[prev])) return Boolean(versionLt(prev, cur));
        else return true;
        if (isLoadingOrLoaded(versions[prev])) return false;
        return versionLt(prev, cur);
    };
    if (useTreesShaking) {
        version = findVersion(shareScopeMap[scope][pkgName], callback);
        if (version) return {
            version,
            useTreesShaking
        };
        useTreesShaking = false;
    }
    return {
        version: findVersion(shareScopeMap[scope][pkgName], callback),
        useTreesShaking
    };
}
function getFindShareFunction(strategy) {
    if (strategy === "loaded-first") return findSingletonVersionOrderByLoaded;
    return findSingletonVersionOrderByVersion;
}
function getRegisteredShare(localShareScopeMap, pkgName, shareInfo, resolveShare) {
    var _loop = function(sc) {
        if (shareConfig && localShareScopeMap[sc] && localShareScopeMap[sc][pkgName]) {
            var requiredVersion = shareConfig.requiredVersion;
            var _getFindShareFunction = getFindShareFunction(strategy)(localShareScopeMap, sc, pkgName, treeShaking), maxOrSingletonVersion = _getFindShareFunction.version, useTreesShaking = _getFindShareFunction.useTreesShaking;
            var defaultResolver = ()=>{
                var shared = localShareScopeMap[sc][pkgName][maxOrSingletonVersion];
                if (shareConfig.singleton) {
                    if (typeof requiredVersion === "string" && !require_index.satisfy(maxOrSingletonVersion, requiredVersion)) {
                        var msg = `Version ${maxOrSingletonVersion} from ${maxOrSingletonVersion && shared.from} of shared singleton module ${pkgName} does not satisfy the requirement of ${shareInfo.from} which needs ${requiredVersion})`;
                        if (shareConfig.strictVersion) require_logger.error(msg);
                        else require_logger.warn(msg);
                    }
                    return {
                        shared,
                        useTreesShaking
                    };
                } else {
                    if (requiredVersion === false || requiredVersion === "*") return {
                        shared,
                        useTreesShaking
                    };
                    if (require_index.satisfy(maxOrSingletonVersion, requiredVersion)) return {
                        shared,
                        useTreesShaking
                    };
                    var _usedTreeShaking = shouldUseTreeShaking(treeShaking);
                    if (_usedTreeShaking) for (var ref of Object.entries(localShareScopeMap[sc][pkgName])){
                        var _ref = _sliced_to_array._(ref, 2), versionKey = _ref[0], versionValue = _ref[1];
                        if (!shouldUseTreeShaking(versionValue.treeShaking, treeShaking === null || treeShaking === void 0 ? void 0 : treeShaking.usedExports)) continue;
                        if (require_index.satisfy(versionKey, requiredVersion)) return {
                            shared: versionValue,
                            useTreesShaking: _usedTreeShaking
                        };
                    }
                    for (var ref1 of Object.entries(localShareScopeMap[sc][pkgName])){
                        var _ref1 = _sliced_to_array._(ref1, 2), versionKey1 = _ref1[0], versionValue1 = _ref1[1];
                        if (require_index.satisfy(versionKey1, requiredVersion)) return {
                            shared: versionValue1,
                            useTreesShaking: false
                        };
                    }
                }
            };
            var params = {
                shareScopeMap: localShareScopeMap,
                scope: sc,
                pkgName,
                version: maxOrSingletonVersion,
                GlobalFederation: require_global.Global.__FEDERATION__,
                shareInfo,
                resolver: defaultResolver
            };
            return {
                v: (resolveShare.emit(params) || params).resolver()
            };
        }
    };
    if (!localShareScopeMap) return;
    var shareConfig = shareInfo.shareConfig, _shareInfo_scope = shareInfo.scope, scope = _shareInfo_scope === void 0 ? require_constant.DEFAULT_SCOPE : _shareInfo_scope, strategy = shareInfo.strategy, treeShaking = shareInfo.treeShaking;
    var scopes = Array.isArray(scope) ? scope : [
        scope
    ];
    for (var sc of scopes){
        var _ret = _loop(sc);
        if (_type_of._(_ret) === "object") return _ret.v;
    }
}
function getGlobalShareScope() {
    return require_global.Global.__FEDERATION__.__SHARE__;
}
function getTargetSharedOptions(options) {
    var pkgName = options.pkgName, extraOptions = options.extraOptions, shareInfos = options.shareInfos;
    var defaultResolver = (sharedOptions)=>{
        if (!sharedOptions) return;
        var shareVersionMap = {};
        sharedOptions.forEach((shared)=>{
            shareVersionMap[shared.version] = shared;
        });
        var callback = function callback(prev, cur) {
            return !isLoaded(shareVersionMap[prev]) && versionLt(prev, cur);
        };
        return shareVersionMap[findVersion(shareVersionMap, callback)];
    };
    var resolver = (extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.resolver) ?? defaultResolver;
    var isPlainObject = (val)=>{
        return val !== null && typeof val === "object" && !Array.isArray(val);
    };
    var merge = function merge1() {
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
            sources[_key] = arguments[_key];
        }
        var out = {};
        for (var src of sources){
            if (!src) continue;
            for (var ref of Object.entries(src)){
                var _ref = _sliced_to_array._(ref, 2), key = _ref[0], value = _ref[1];
                var prev = out[key];
                if (isPlainObject(prev) && isPlainObject(value)) out[key] = merge(prev, value);
                else if (value !== void 0) out[key] = value;
            }
        }
        return out;
    };
    return merge(resolver(shareInfos[pkgName]), extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.customShareInfo);
}
var addUseIn = (shared, from)=>{
    if (!shared.useIn) shared.useIn = [];
    require_tool.addUniqueItem(shared.useIn, from);
};
function directShare(shared, useTreesShaking) {
    if (useTreesShaking && shared.treeShaking) return shared.treeShaking;
    return shared;
}
//#endregion
exports.addUseIn = addUseIn;
exports.directShare = directShare;
exports.formatShareConfigs = formatShareConfigs;
exports.getGlobalShareScope = getGlobalShareScope;
exports.getRegisteredShare = getRegisteredShare;
exports.getTargetSharedOptions = getTargetSharedOptions;
exports.shouldUseTreeShaking = shouldUseTreeShaking; //# sourceMappingURL=share.cjs.map
